import { getConditionsFilterConfig } from '../filters/condition';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getGenderFilterConfig } from '../filters/gender';
import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { BuilderSections } from '../../util/builder';

export const southerntideSizes = [
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '1SZ',

  // Women's Numeric Pant Sizes
  '0',
  '2',
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',

  // Men's Numeric Pant Sizes
  '28',
  '30',
  '32',
  '34',
  '35',
  '36',
  '38',
  '40',
  '42',
  '44',
  '46',
  '48',

  // Men's W x L Pant Sizes
  '28W x 30L',
  '28W x 32L',
  '28W x 34L',
  '30W x 30L',
  '30W x 32L',
  '30W x 34L',
  '32W x 30L',
  '32W x 32L',
  '32W x 34L',
  '33W x 30L',
  '33W x 32L',
  '33W x 34L',
  '34W x 30L',
  '34W x 32L',
  '34W x 34L',
  '35W x 30L',
  '35W x 32L',
  '35W x 34L',
  '36W x 30L',
  '36W x 32L',
  '36W x 34L',
  '38W x 30L',
  '38W x 32L',
  '38W x 34L',
  '40W x 30L',
  '40W x 32L',
  '40W x 34L',
  '42W x 30L',
  '42W x 32L',
  '42W x 34L',
];

export const southerntideShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getBrandDirectFilterConfig(),
    getConditionsFilterConfig(),
    getGenderFilterConfig(),
    getSizeFilterConfig({ sizes: southerntideSizes }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '041e9359064a4f9eb42715f470d694f5',
    },
  },
  homepageCategories: [
    {
      searchQuery: '?pub_category=men&mode=filter-change',
      label: 'Men',
    },
    {
      searchQuery: '?pub_category=women&mode=filter-change',
      label: 'Women',
    },
    {
      searchQuery: '?pub_category=kids&mode=filter-change',
      label: 'Kids',
    },
  ],
};
